// extracted by css-extract-rspack-plugin
export default {"cls1":"Star-cls1_BvJ","cls2":"Star-cls2_eb4 Star-cls1_BvJ","selected":"Star-selected_8bC","hovered":"Star-hovered_hCn"};